export var BadgeColor = {
  Primary: 'primary',
  Secondary: 'secondary',
  White: 'white'
};